define('plugin/news/view/NewsDetailsView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * News details view
     *
     * @class NewsDetailsView
     */
    return LayoutView.extend({

        template: '#news_details_view',
        modelEvents: {
            'sync': 'render'
        },
        collectionEvents: {
            'sync': 'render'
        },

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);

            var model = this.collection.get(this.model.get('id'));
            if (model) {
                var index = this.collection.indexOf(model);

                if (index > 0) {
                    data.prev_article = this.collection.at(index - 1).toJSON();
                }
                if (index < this.collection.size() - 1) {
                    data.next_article = this.collection.at(index + 1).toJSON();
                }
            }
            return data;
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'news_details'
            });
        }

    });

});
